import { MenuList } from '../../../../../types/menu';
import { UserAuth } from '../../../../../types/user';
import { ThemeSystem } from '../../../../../views/my-learning/dashboard/themeColor';
import MainContent from './MainContent';

export default MainContent;

export interface MainContentProps {
  children: React.ReactNode;
  user: UserAuth;
  menuList: MenuList[];
  classes?: string;
  theme?: ThemeSystem;
}
